import React from 'react';
import { ArrowRight } from 'lucide-react';

const PathwayCard = ({ 
  icon: Icon, 
  title, 
  subtitle, 
  description, 
  bullets, 
  buttonText, 
  onClick, 
  bgColor, 
  borderColor, 
  iconColor,
  customContent 
}) => {
  return (
    <div 
      className={`${bgColor} ${borderColor} border-2 rounded-xl p-6 h-full flex flex-col transition-all duration-300 hover:shadow-xl hover:scale-105 cursor-pointer touch-manipulation`}
      onClick={onClick}
    >
      {/* Icon and Title Section */}
      <div className="flex items-center mb-6">
        <div className={`${iconColor} mr-4`}>
          <Icon size={48} />
        </div>
        <div>
          <h2 className="text-2xl font-bold text-gray-900 mb-0 uppercase">{title}</h2>
          {subtitle && (
            <p className="text-lg font-semibold text-gray-700">{subtitle}</p>
          )}
        </div>
      </div>

      {/* Content Area - grows to fill available space */}
      <div className="flex-grow flex flex-col">
        {/* Custom Content (with description) or Fallback to Description + Bullets */}
        {customContent ? (
          customContent
        ) : (
          <>
            {/* Description */}
            <p className="text-gray-700 text-lg leading-relaxed mb-6">
              {description}
            </p>

            {/* Bullet Points */}
            <div className="flex-grow">
              {bullets.map((bullet, index) => (
                <div key={index} className="flex items-start mb-3">
                  <span className="text-gray-400 mr-3 mt-1">•</span>
                  <p className="text-gray-700 text-base leading-relaxed">
                    {bullet.text}
                    {bullet.highlight && (
                      <span className="font-bold text-gray-900">{bullet.highlight}</span>
                    )}
                    {bullet.suffix}
                  </p>
                </div>
              ))}
            </div>
          </>
        )}
      </div>

      {/* Call to Action Button */}
      <button 
        className="bg-brandOrange hover:bg-orange-600 text-white font-bold py-4 px-8 rounded-lg text-xl transition-all duration-200 flex items-center justify-center group touch-manipulation min-h-[60px] mt-8"
        onClick={(e) => {
          e.stopPropagation();
          onClick && onClick();
        }}
      >
        {buttonText}
        <ArrowRight 
          size={24} 
          className="ml-2 transition-transform duration-200 group-hover:translate-x-1" 
        />
      </button>
    </div>
  );
};

export default PathwayCard;